import { LuLayoutDashboard } from 'react-icons/lu'
import { FaBoxOpen, FaBuildingUser } from 'react-icons/fa6'
import { BsBank, BsCart4 } from 'react-icons/bs'
import { GrTransaction, GrUserManager } from 'react-icons/gr'
import { FaUserCog, FaUsers } from 'react-icons/fa'
import { IoAnalytics } from 'react-icons/io5'
import { ImBoxAdd } from 'react-icons/im'

const appRoutes = [
    {
        text: 'Menu',
        child: [
            {
                url: '/store_user',
                text: 'Dashboard',
                permission: 'dashboard',
                icon: <LuLayoutDashboard />,
            },
            {
                active: ['/store_user/roles'],
                url: '/store_user/roles',
                text: 'Roles',
                permission: 'roles.index',
                icon: <FaUserCog />,
            },
            {
                active: ['/store_user/store-users'],
                url: '/store_user/store-users',
                text: 'Store Users',
                permission: 'store_users.index',
                icon: <FaBuildingUser />,
            },
            {
                active: ['/store_user/bank-accounts'],
                url: '/store_user/bank-accounts',
                text: 'Bank Accounts',
                permission: 'bank_accounts.index',
                icon: <BsBank />,
            },
            {
                active: ['/store_user/bank-transactions'],
                url: '/store_user/bank-transactions',
                text: 'Bank Transactions',
                permission: 'bank_transactions.index',
                icon: <GrTransaction />,
            },
            {
                active: ['/store_user/wallet-transactions'],
                url: '/store_user/wallet-transactions',
                text: 'Wallet Transactions',
                permission: 'wallet_transactions.index',
                icon: <GrTransaction />,
            },
            {
                active: ['/store_user/customers'],
                url: '/store_user/customers',
                text: 'Customers',
                permission: 'customers.index',
                icon: <FaUsers />,
            },
            {
                active: ['/store_user/vendors'],
                url: '/store_user/vendors',
                text: 'Vendors',
                permission: 'vendors.index',
                icon: <GrUserManager />,
            },
            {
                active: ['/store_user/products'],
                url: '/store_user/products',
                text: 'Products',
                permission: 'products.index',
                icon: <FaBoxOpen />,
            },
            {
                active: ['/store_user/purchases'],
                url: '/store_user/purchases',
                text: 'Purchases',
                permission: 'purchases.index',
                icon: <ImBoxAdd />,
            },
            {
                active: ['/store_user/store-orders'],
                url: '/store_user/store-orders',
                text: 'Store Orders',
                permission: 'store_orders.index',
                icon: <BsCart4 />,
            },
            {
                active: ['/store_user/orders'],
                url: '/store_user/orders',
                text: 'Customer Orders',
                permission: 'orders.index',
                icon: <BsCart4 />,
            },
            {
                active: ['/store_user/analysis'],
                text: 'Analysis',
                icon: <IoAnalytics />,
                permission: ['purchases.products', 'store_orders.products', 'orders.products'],
                child: [
                    {
                        active: ['/store_user/analysis/purchases'],
                        url: '/store_user/analysis/purchases',
                        text: 'Purchases',
                        permission: 'purchases.products',
                        icon: <ImBoxAdd />,
                    },
                    {
                        active: ['/store_user/analysis/store-orders'],
                        url: '/store_user/analysis/store-orders',
                        text: 'Store Orders',
                        permission: 'store_orders.products',
                        icon: <ImBoxAdd />,
                    },
                    {
                        active: ['/store_user/analysis/orders'],
                        url: '/store_user/analysis/orders',
                        text: 'Customer Orders',
                        permission: 'orders.products',
                        icon: <BsCart4 />,
                    },
                ],
            },
        ],
    },
]

export default appRoutes
